import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const WritingAIIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.07071 1.49497L5.39994 3.7996C5.4599 4.21932 5.77803 4.55561 6.19378 4.63876L7.50971 4.90194C7.79479 4.95896 8 5.20927 8 5.5C8 5.79073 7.79479 6.04104 7.50971 6.09806L6.19378 6.36124C5.77803 6.44439 5.4599 6.78068 5.39994 7.2004L5.07071 9.50503C5.03014 9.78904 4.7869 10 4.5 10C4.2131 10 3.96986 9.78904 3.92929 9.50502L3.60006 7.2004C3.5401 6.78068 3.22197 6.44439 2.80622 6.36124L1.51453 6.10291C1.21535 6.04307 1 5.78038 1 5.47528C1 5.16435 1.22345 4.8984 1.52973 4.8448L2.78507 4.62511C3.21146 4.55049 3.54143 4.21002 3.60264 3.7815L3.92929 1.49497C3.96986 1.21096 4.2131 1 4.5 1C4.7869 1 5.03014 1.21096 5.07071 1.49497Z"
		></path>
		<path
			fill="currentColor"
			d="M14.6301 4.36988C15.1233 4.86305 15.1233 5.66261 14.6301 6.15578L14.0268 6.75908C13.8316 6.95434 13.515 6.95434 13.3197 6.75908L12.2409 5.68027C12.0457 5.48501 12.0457 5.16843 12.2409 4.97317L12.8442 4.36988C13.3374 3.87671 14.137 3.87671 14.6301 4.36988Z"
		></path>
		<path
			fill="currentColor"
			d="M12.2591 7.81975C12.4544 8.01501 12.4544 8.33159 12.2591 8.52686L7.07689 13.7091C6.31194 14.4741 5.29374 14.9331 4.21398 14.9996C4.09306 15.0071 3.99293 14.9069 4.00039 14.786C4.06704 13.7063 4.526 12.6882 5.29089 11.9233L10.4732 6.74095C10.6684 6.54568 10.985 6.54568 11.1803 6.74094L12.2591 7.81975Z"
		></path>
	</svg>
))
